import { FanPageView } from "@/components/fanpage/FanPageView";

export function SharePreviewFrame({ page }) {
  return (
    <div className="flex justify-center" data-testid="share-preview-frame">
      <div className="w-[280px] h-[560px] rounded-[32px] border-[6px] border-white/15 bg-black overflow-hidden shadow-2xl relative">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-4 bg-black rounded-b-xl z-10" />
        <div className="w-full h-full overflow-y-auto">
          <FanPageView page={page} scale="preview" />
        </div>
      </div>
    </div>
  );
}
